const sidebarMinWidth = 380;
const sidebarRightMinWidth = 500;
const state = {
  sideBarItems: [],
  sideBarRightItems: [],// para pasar del side bar al otro side bar
  bottomBarItems: [],
  sidebarStartDragging: false,
  sidebarWidth: 580,
  sidebarRightStartDragging: false,
  sidebarRightWidth: 580,
  alarm_id: null,
};

const getters = {
  sidebarMinWidthReached(state) {
    return sidebarMinWidth > state.sidebarWidth;
  },
  sidebarRighMinWidthReached(state) {
    return sidebarRightMinWidth > state.sidebarRightWidth;
  },
  alarmId(state) {
    return state.alarm_id;
  },
};

const mutations = {
  setSideBarItems(state, value) {
    state.sideBarItems = value;
  },
  setSideBarRightItems(state, items) { // 
    state.sideBarRightItems = items;
  },
  setSidebarStartDragging(state, value) {
    state.sidebarStartDragging = value;
  },
  setSidebarRightStartDragging(state, value) {
    state.sidebarRightStartDragging = value;
  },
  setBottomBarItems(state, value) {
    state.bottomBarItems = value;
  },
  setAlarmId(state, value) {
    state.alarm_id = value;
  },
  updateWidgetStatus(state, value) {
    const location = value.location === 'sideBar' ? 'sideBarItems' : 'bottomBarItems';
    const item = state[location].find(item => item.id === value.id);
    if (item) item[value.property] = value.value;
  },
  updateSidebarWidth(state, value) {
    state.sidebarWidth = value;
  },
  updateSidebarRightWidth(state, value) {
    state.sidebarRightWidth = value;
  }
};

const actions = {
  setSideBarItems({ commit, dispatch }, data) {
    commit('setSideBarItems', data);
    dispatch('updateUserConfig');
  },
  setSideBarRightItems({ commit }, items) {
    commit("setSideBarRightItems", items);
  },
  setBottomBarItems({ commit }, data) {
    commit('setBottomBarItems', data);
  },
  setAlarmId({ commit }, data) {
    commit('setAlarmId', data);
  },
  updateWidgetStatus({ commit, dispatch }, data) {
    commit('updateWidgetStatus', data);
    dispatch('updateUserConfig');
  },
  moveWidget({ state, commit, dispatch }, { widget, from, to, newList }) {

    const fromKey = from === "left" ? "sideBarItems" : "sideBarRightItems";
    const toKey   = to   === "left" ? "sideBarItems" : "sideBarRightItems";
  
    const updatedOrigin = state[fromKey].filter(it => it.id !== widget.id);
    if (from === "left") {
      commit("setSideBarItems", updatedOrigin);
    } else {
      commit("setSideBarRightItems", updatedOrigin);
    }
  
    if (to === "left") {
      commit("setSideBarItems", newList);
    } else {
      commit("setSideBarRightItems", newList);
    }
  
    dispatch("updateUserConfig");
  }
  
};

export default {
  state,
  getters,
  mutations,
  actions
};
